export class ScrollOptions {
    instant: boolean = true;
}

const WindowHelper = {
    ScrollToTop: (config: ScrollOptions = { instant: true }) => window.scrollTo({ top: 0, left: 0, behavior: (config.instant ? 'instant' : 'smooth') as ScrollBehavior }),
    ScrollToElement: (ref: any, config: ScrollOptions = { instant: true }) => ref.scrollIntoView({ behavior: (config.instant ? 'instant' : 'smooth') as ScrollBehavior })
}

export default WindowHelper;